import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import Loader from "../../components/shared/Loader";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { useDropzone } from "react-dropzone";
import { set } from "react-hook-form";

const ServiceShow = ({ match }) => {
	const {
		params: { serviceID },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [pageContent, setPageContent] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);

	const [files, setFiles] = useState([]);

	const [mainPicture, setMainPicture] = useState(null);
	const [singleCatalog, setSingleCatalog] = useState(null);
	const [singleCatalogName, setSingleCatalogName] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
	const [measurementUnitEn , setMeasurementUnitEn] = useState("");
	const [measurementUnit , setMeasurementUnit] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [isImageChanged, setIsImageChanged] = useState(false);
	const [price, setPrice] = useState("");

	const dispatch = useDispatch();

	let editor = null;

	useEffect(() => {
		onStart();
	}, []);

	useEffect(
		() => () => {
			files.forEach(file => URL.revokeObjectURL(file.preview));
		},
		[files]
	);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل السعر",
				breadcrumb: "قائمة الاسعار",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/pricesList/${serviceID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setLoading(false);
				setTitle(response.data.data.title?.ar);
				setTitleEn(response.data.data.title?.en);
				setDescription(response.data.data.description?.ar);
				setDescriptionEn(response.data.data.description?.en);
				setPrice(response.data.data.price);
				setPicture(response.data.data.image);
				setMeasurementUnit(response.data.data.measurementUnit?.ar);
				setMeasurementUnitEn(response.data.data.measurementUnit?.en);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handleImageUpload = async (e, id) => {
		if (id === "#mainPicture" && mainPicture === null) {
			toast.error("برجاء إختيار صورة اولا");
			return;
		}
		if (id === "#singleCatalog" && singleCatalog === null) {
			toast.error("برجاء إختيار الملف  اولا");
			return;
		}
		if (id === "#picture" && picture === null) {
			toast.error("برجاء إختيار صورة اولا");
			return;
		}
		e.preventDefault();
		setLoading(true);
		const fileInput = document.querySelector(id);
		const formData = new FormData();
		formData.append("file", fileInput.files[0]);
		await axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(function (responseImage) {
				if (id === "#picture") {
					setPicture(responseImage.data.data.name);
					setLoading(false);
					setIsImageChanged(true);
				}
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
				return;
			});

		setLoading(false);
		toast.success("تم رفع الصور بنجاح!");
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (!title || !titleEn) {
			toast.error("برجاء أدخال العنوان");
			return;
		}

		if (!description) {
			toast.error("برجاء أدخال الوصف");
			return;
		}
		if (!picture) {
			toast.error("برجاء أدخال الصورة");
			return;
		}

		setLoading(true);
		const data = {
			id: serviceID,
			title: {
				ar: title,
				en: titleEn,
			},
			description: {
				ar: description,
				en: descriptionEn,
			},
			image: picture,
			price: price,
			measurementUnit: {
				ar: measurementUnit,
				en: measurementUnitEn,}
		};
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/pricesList/${serviceID}`,
				{
					...data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث سعر الخدمة بنجاح!");
				history.push("/servicesPrices/index");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="title">العنوان</label>
										<input
											type="text"
											id="title"
											required
											value={title}
											onChange={e => setTitle(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="titleEn">العنوان الانجليزي</label>
										<input
											type="text"
											id="titleEn"
											required
											dir="ltr"
											value={titleEn}
											onChange={e => setTitleEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="description">الوصف</label>
										<input
											type="text"
											id="description"
											required
											value={description}
											onChange={e => setDescription(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="descriptionEn"> الوصف الانجليزي</label>
										<input
											type="text"
											id="descriptionEn"
											required
											dir="ltr"
											value={descriptionEn}
											onChange={e => setDescriptionEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-item col-md-6 ">
										<label htmlFor="price">السعر</label>
										<input
											type="text"
											id="حقهؤث"
											required
											dir="rtl"
											value={price}
											onChange={e => setPrice(e.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="measurementUnitAr">الترميز/وحدة القياس(عربي)</label>
										<input
											type="text"
											id="measurementUnitAr"
											required
											value={measurementUnit}
											onChange={e => setMeasurementUnit(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="measurementUnitEn"> الترميز/وحدة القياس(انجليزي)</label>
										<input
											type="text"
											id="measurementUnitEn"
											required
											dir="ltr"
											value={measurementUnitEn}
											onChange={e => setMeasurementUnitEn(e.target.value)}
										/>
									</div>

								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input
										type="file"
										onChange={e => handleImageUpload(e, "#picture")}
										id="picture"
									/>
									{picture && (
										<div className="img-holder">
											<img
												src={`${process.env.REACT_APP_MAIN_URL}${picture}`}
												alt="avatar"
												className="imagePreview"
											/>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default ServiceShow;
